export const FILTER_CATEGORIES = {
  talea_application: {
    label: 'TALEA Application',
    icon: '🏙️',
    color: '#004d19',
    options: ['Nodal', 'Linear', 'Fragmented'],
    dataKey: 'talea_application',
    type: 'object',
  },
  size: {
    label: 'Size',
    icon: '📐',
    color: '#1272B7',
    options: ['Small', 'Medium', 'Large'],
    dataKey: 'size',
    type: 'value',
  },
  climate_zone: {
    label: 'Climate Zone',
    icon: '🌡️',
    color: '#21A84A',
    options: ['Tropical', 'Arid', 'Mediterranean', 'Temperate', 'Cold/Boreal', 'Polar'],
    dataKey: 'climate_zone',
    type: 'value',
  },
  a1_urban_scale: {
    label: 'A1 Urban Scale',
    icon: '🏗️',
    color: '#21A84A',
    options: ['Territorial', 'Metropolitan', 'Urban', 'District', 'Urban block', 'Single space or building'],
    dataKey: 'a1_urban_scale',
    type: 'array',
  },
  a2_urban_area: {
    label: 'A2 Urban Area',
    icon: '📍',
    color: '#d69e2e',
    options: ['Historical centre', 'Consolidated city', 'Peripheral area', 'Rural area'],
    dataKey: 'a2_urban_area',
    type: 'array',
  },
  a3_1_buildings: {
    label: 'A3.1 Buildings',
    icon: '🏠',
    color: '#1272B7',
    options: ['Building / pavilion', 'Building complex', 'Building façade', 'Rooftop'],
    dataKey: 'a3_1_buildings',
    type: 'array',
  },
  a3_2_open_spaces: {
    label: 'A3.2 Open Spaces',
    icon: '🌳',
    color: '#21A84A',
    options: ['Courtyard', 'Entrance area', 'Green area (park / garden)', 'Open paved space', 'Parking area', 'Residual space or widening', 'Service yard or technical area', 'Square', 'Waterfront'],
    dataKey: 'a3_2_open_spaces',
    type: 'array',
  },
  a3_3_infrastructures: {
    label: 'A3.3 Infrastructures',
    icon: '🛤️',
    color: '#1272B7',
    options: ['Carriageway', 'Cycle lane (dedicated)', 'Cycle lane with sidewalk', 'Disused railway or similar', 'Drainage channel / urban ditch', 'Footpath', 'Overpass or viaduct', 'Pedestrian street', 'Sidewalk', 'Sidewalk on commercial axis', 'Traffic island', 'Tramway trackbed'],
    dataKey: 'a3_3_infrastructures',
    type: 'array',
  },
  a4_ownership: {
    label: 'A4 Ownership',
    icon: '🔑',
    color: '#004d19',
    options: ['Public', 'Private', 'Mixed (public/private)'],
    dataKey: 'a4_ownership',
    type: 'array',
  },
  a5_management: {
    label: 'A5 Management',
    icon: '📋',
    color: '#1272B7',
    options: ['Association', "Citizens' committee", 'Mixed (public/private)', 'Neighbourhood', 'Private', 'Public'],
    dataKey: 'a5_management',
    type: 'array',
  },
  a6_uses: {
    label: 'A6 Uses',
    icon: '🎯',
    color: '#21A84A',
    options: ['Commercial', 'Cultural', 'Educational', 'Events', 'Multifunctional', 'Outdoor activities', 'Performance', 'Recreational', 'Refreshment point', 'Residential', 'Slow mobility (walking / bike / bus)', 'Social', 'Sports', 'Temporary use', 'Unconventional use', 'Vegetable garden'],
    dataKey: 'a6_uses',
    type: 'array',
  },
  a7_other: {
    label: 'A7 Other',
    icon: '📌',
    color: '#004d19',
    options: ['Abandoned / underused area', 'In-between space', 'Neighbourhood space'],
    dataKey: 'a7_other',
    type: 'array',
  },
  b1_physical: {
    label: 'B1 Physical Constraints',
    icon: '⚠️',
    color: '#c53030',
    options: ['Aerial cables / power lines', 'Critical slopes / steep gradients', 'Existing large tree or plant roots', 'High levels of soil pollution', 'Impermeable or rigidly paved soil', 'Limited technical accessibility', 'Narrow spaces / complex morphologies', 'Subsurface utilities'],
    dataKey: 'b1_physical',
    type: 'array',
  },
  b2_regulations: {
    label: 'B2 Regulations',
    icon: '📜',
    color: '#d69e2e',
    options: ['Architectural barrier regulations', 'Building codes and technical standards', 'Flood risk / hydrogeological constraint', 'Heritage/archaeological constraint', 'Landscape protection constraint', 'Public property rules / easements', 'Urban safety/surveillance rules'],
    dataKey: 'b2_regulations',
    type: 'array',
  },
  b3_uses_management: {
    label: 'B3 Uses & Management',
    icon: '🔄',
    color: '#21A84A',
    options: ['Commercial buildings/services', 'Consolidated use / uses', 'Digital infrastructure', 'Functional equipment', 'Green/blue infrastructure', 'Maintenance assigned to third parties', 'Mobility infrastructure/hubs', 'Public art and/or monuments', 'Public cultural buildings/services', 'Sensitive signage', 'Use conflicts', 'Vulnerable or sensitive users'],
    dataKey: 'b3_uses_management',
    type: 'array',
  },
  b4_public_opinion: {
    label: 'B4 Public Opinion',
    icon: '💬',
    color: '#1272B7',
    options: ['Collective memory / identity belonging', 'Fear of decay / improper use', 'Perception of the space as "private"', 'Rejection or distrust of greenery'],
    dataKey: 'b4_public_opinion',
    type: 'array',
  },
  b5_synergy: {
    label: 'B5 Synergy',
    icon: '🤝',
    color: '#004d19',
    options: ['Existing regeneration projects', 'Municipal or metropolitan plans', 'Ongoing public or private investments'],
    dataKey: 'b5_synergy',
    type: 'array',
  },
  b6_social_opportunities: {
    label: 'B6 Social Opportunities',
    icon: '🌟',
    color: '#21A84A',
    options: ['Civic participation', 'Community building / social cohesion', 'Cultural and intercultural exchange', 'Educational opportunities', 'Health promotion / active lifestyles', 'Inclusion', 'Intergenerational exchange', 'Safety and perception of security', 'Universal accessibility', 'Volunteering and active citizenship', 'Well-being'],
    dataKey: 'b6_social_opportunities',
    type: 'array',
  },
  c1_1_design: {
    label: 'C1.1 Design Process',
    icon: '✏️',
    color: '#1272B7',
    options: ['Co-design', 'Community engagement', 'Cultural promotion', 'Open call/ competition', 'Public consultation', 'Research project', 'Self-build', 'Social innovation', 'Spontaneous intervention', 'Workshop'],
    dataKey: 'c1_1_design',
    type: 'array',
  },
  c1_2_funding: {
    label: 'C1.2 Funding',
    icon: '💰',
    color: '#21A84A',
    options: ['Crowdfunding', 'Partnership', 'Private funding', 'Public funding'],
    dataKey: 'c1_2_funding',
    type: 'array',
  },
  c1_3_management: {
    label: 'C1.3 Management',
    icon: '⚙️',
    color: '#d69e2e',
    options: ['Collaboration agreement', 'Private', 'Public'],
    dataKey: 'c1_3_management',
    type: 'array',
  },
  c2_actors: {
    label: 'C2 Actors',
    icon: '👥',
    color: '#1272B7',
    options: ['Age groups', 'Artists', 'Associations', 'Citizens', 'Committees', 'Cultural centres', 'Designers', 'Facilitators', 'Foundations', 'Groups of citizens', 'Local Association', 'Neighbourhood councils', 'Non-profit organizations', 'Public institutions', 'Research centres', 'Residents', 'Shopkeepers', 'Students', 'Universities', 'Volunteers', 'Vulnerable individuals'],
    dataKey: 'c2_actors',
    type: 'array',
  },
  c3_goals: {
    label: 'C3 Goals & Results',
    icon: '🎯',
    color: '#004d19',
    options: ['Accessibility', 'Biodiversity', 'Care', 'Climate change mitigation', 'Environmental sustainability', 'Intergenerational collaboration', 'Knowledge', 'Liveability', 'New connections', 'New perception', 'New production', 'Re-activation', 'Re-appropriation', 'Resilience', 'Safety', 'Sense of community', 'Social inclusion', 'Transformation', 'Urban regeneration', 'Valorisation'],
    dataKey: 'c3_goals',
    type: 'array',
  },
  c4_services: {
    label: 'C4 Services',
    icon: '🛎️',
    color: '#21A84A',
    options: ['Access free to water', 'Areas for meeting residents', 'Areas with shade/cool spots', 'Benches/rest areas', 'Care and maintenance services', 'Educational - leisure and cultural uses', 'Monitoring and warning systems', 'Online maps / informative materials'],
    dataKey: 'c4_services',
    type: 'array',
  },
  d1_plants: {
    label: 'D1 Plants',
    icon: '🌿',
    color: '#21A84A',
    options: ['Dense hedges', 'Ecological corridors - Pollinator-friendly gardens', 'Flower beds', 'Linear hedges', 'Row of trees', 'Rows / tree lines', 'Shading tree groups / tree clusters', 'Shrub patches', 'Single tree'],
    dataKey: 'd1_plants',
    type: 'array',
  },
  d2_paving: {
    label: 'D2 Paving',
    icon: '🧱',
    color: '#004d19',
    options: ['Depaving', 'Permeable paving'],
    dataKey: 'd2_paving',
    type: 'array',
  },
  d3_water: {
    label: 'D3 Water',
    icon: '💧',
    color: '#1272B7',
    options: ['Artificial wetlands', 'Bioretention areas', 'Detention basins', 'Filter trenches / strips / drains', 'Floodable park', 'Fountains', 'Ground-level fountain', 'Green channels', 'Mist sprayers', 'Rain garden', 'Rain plaza', 'Reopened canals', 'Urban wetlands', 'Vegetated ditches', 'Water blades', 'Water mirror'],
    dataKey: 'd3_water',
    type: 'array',
  },
  d4_roof_facade: {
    label: 'D4 Roof & Facade',
    icon: '🏢',
    color: '#21A84A',
    options: ['Climbing structures on walls or nets', 'Extensive green roofs', 'Green walls', 'Intensive green roofs', 'Vegetal sunshades'],
    dataKey: 'd4_roof_facade',
    type: 'array',
  },
  d5_furnishings: {
    label: 'D5 Furnishings',
    icon: '🪑',
    color: '#d69e2e',
    options: ['Green integrated furnishings', 'Green mobile covers', 'Green rigid covers', 'Green shelters', 'Prefabricated green modules', 'Vegetated awnings'],
    dataKey: 'd5_furnishings',
    type: 'array',
  },
  d6_urban_spaces: {
    label: 'D6 Urban Spaces',
    icon: '🌳',
    color: '#004d19',
    options: ['Community gardens', 'Green spaces in infrastructures (underpasses / viaducts)', 'Micro parks', 'Multifunctional green spaces', 'Urban gardens'],
    dataKey: 'd6_urban_spaces',
    type: 'array',
  },
  innovation: {
    label: 'Innovation',
    icon: '💡',
    color: '#e07c3a',
    options: ['Physical', 'Social', 'Digital'],
    dataKey: 'innovation',
    type: 'innovation',
  },
};

export const FILTER_GROUPS = {
  core: {
    label: 'Core',
    icon: '⭐',
    categories: ['talea_application', 'size', 'climate_zone', 'innovation'],
  },
  physical: {
    label: 'A - Physical',
    icon: '🏗️',
    categories: ['a1_urban_scale', 'a2_urban_area', 'a3_1_buildings', 'a3_2_open_spaces', 'a3_3_infrastructures', 'a4_ownership', 'a5_management', 'a6_uses', 'a7_other'],
  },
  constraints: {
    label: 'B - Constraints',
    icon: '⚡',
    categories: ['b1_physical', 'b2_regulations', 'b3_uses_management', 'b4_public_opinion', 'b5_synergy', 'b6_social_opportunities'],
  },
  design: {
    label: 'C - Design',
    icon: '🎨',
    categories: ['c1_1_design', 'c1_2_funding', 'c1_3_management', 'c2_actors', 'c3_goals', 'c4_services'],
  },
  nbs: {
    label: 'D - NBS',
    icon: '🌿',
    categories: ['d1_plants', 'd2_paving', 'd3_water', 'd4_roof_facade', 'd5_furnishings', 'd6_urban_spaces'],
  },
};

export const NBS_CATEGORIES = {
  'd1_plants': { label: 'D1 Plants', icon: '🌿', color: '#21A84A' },
  'd2_paving': { label: 'D2 Paving', icon: '🧱', color: '#004d19' },
  'd3_water': { label: 'D3 Water', icon: '💧', color: '#1272B7' },
  'd4_roof_facade': { label: 'D4 Roof & Facade', icon: '🏢', color: '#21A84A' },
  'd5_furnishings': { label: 'D5 Furnishings', icon: '🪑', color: '#d69e2e' },
  'd6_urban_spaces': { label: 'D6 Urban Spaces', icon: '🌳', color: '#004d19' },
};
